export default {
      id: "contacts_phone-usage",
      viewBox: "0 0 54 54",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#contacts_phone",
      toString: function () {
        return this.url;
      }
    }